import {
  Wand2,
  MessageSquareText,
  Brain,
  Bell,
  Languages,
  ShieldCheck,
} from "lucide-react";
import { HOME } from "@/constants/testIds";

const FEATURES = [
  {
    slug: "proposals",
    icon: Wand2,
    title: "AI proposals that read like you wrote them",
    body: "Paste the job post — get a tailored, human-sounding proposal in seconds. MACHA keeps your voice and trims the fluff clients skip past.",
  },
  {
    slug: "rewrite",
    icon: MessageSquareText,
    title: "One-click message rewrite",
    body: "Highlight any reply and shorten, soften, sharpen, or translate. No more re-reading a message twelve times before hitting send.",
  },
  {
    slug: "tone",
    icon: Brain,
    title: "Tone matching that respects the client",
    body: "Confident with C-suite, warm with creators, technical with engineers. MACHA reads the thread and matches the register automatically.",
  },
  {
    slug: "followups",
    icon: Bell,
    title: "Follow-ups you'd actually forget to send",
    body: "Schedule polite nudges at the right intervals. Never lose a hot lead because life got busy on a Tuesday.",
  },
  {
    slug: "languages",
    icon: Languages,
    title: "Sound native in 24+ languages",
    body: "Working with clients in Berlin, Tokyo, or São Paulo? Reply naturally in their language without sounding like a translator.",
  },
  {
    slug: "private",
    icon: ShieldCheck,
    title: "Private by default",
    body: "Your client conversations never train public models. Your drafts, your data — encrypted and yours to delete anytime.",
  },
];

export function Features() {
  return (
    <section
      data-testid={HOME.featuresSection}
      className="mx-auto w-full max-w-6xl px-5 py-24 sm:px-8 sm:py-32"
    >
      <div className="max-w-2xl">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
          The copilot
        </p>
        <h2 className="mt-3 text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          Every stage of client communication, handled.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground">
          MACHA isn&apos;t a proposal generator. It&apos;s the layer between
          you and every Upwork, Fiverr and Freelancer message — quietly
          improving win-rate, tone, and turnaround.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map(({ slug, icon: Icon, title, body }) => (
          <article
            key={slug}
            data-testid={HOME.featureCard(slug)}
            className="group flex flex-col gap-3 bg-card p-7 transition-colors hover:bg-card/80"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-background text-muted-foreground transition-colors group-hover:border-primary/40 group-hover:text-primary">
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
            </span>
            <h3 className="text-[15px] font-semibold tracking-tight text-foreground">
              {title}
            </h3>
            <p className="text-[13.5px] leading-relaxed text-muted-foreground">
              {body}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
